<template>
  <styled-wrapper data-version="dataVersion">
    <styled-container>
      <styled-paragraph>
        <img
          src="data:image/svg+xml;base64,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"
          alt="BERNEXPO"
          width="209"
        />
      </styled-paragraph>

      <styled-paragraph>
        <styled-span>{{ i18n[language].addressLine1 }}</styled-span>
        <styled-span>{{ i18n[language].addressLine2 }}</styled-span>
        <styled-span>{{ i18n[language].addressLine3 }}</styled-span>
        <styled-span>{{ i18n[language].addressLine4 }}</styled-span>
        <styled-span-phone>
          <styled-span>
            {{ i18n[language].labelPhone }}
            <a href="tel:0041313401111">+41 31 340 11 11</a>
          </styled-span>
        </styled-span-phone>
      </styled-paragraph>

      <styled-nav>
        <ul>
          <li v-for="(item, index) in parsedNavItem" :key="index">
            <a :href="item.url[language]">
              {{ item.title[language] }}
            </a>
          </li>
        </ul>
      </styled-nav>
    </styled-container>
  </styled-wrapper>
</template>

<script>
import styled from "vue-styled-components";

const styledNav = styled.nav`
  > ul {
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    list-style: none;
    > li {
      padding: 0 1em;
      > a {
        font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
        color: #bba868;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
          color: #bba868 !important;
        }
      }
    }

    @media (max-width: 960px) {
      display: block;
      font-size: 16.5px;
    }
  }
`;
const styledParagraph = styled.p`
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  width: 100%;
  background-color: #f6f6f6;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  color: #bba868;
  text-align: center;
  line-height: 1.5;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;
const styledSpan = styled.span`
  box-sizing: inherit;
  display: inline-block;
  font-weight: 300;
  font-style: normal;
  color: #bba868;
  text-align: center;
  line-height: 1.5;
  & + & {
    &:before {
      display: inline-block;
      content: "\\25CF";
      padding-left: 0.6em;
      padding-right: 0.6em;
    }
  }

  > a {
    color: #bba868;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      color: #bba868 !important;
    }
  }

  @media (max-width: 960px) {
    display: block;
    font-size: 16.5px;
    & + & {
      &:before {
        display: block;
        content: "";
        padding-left: 0;
        padding-right: 0;
      }
    }
  }
`;
const styledSpanPhone = styled.span`
  box-sizing: inherit;
  display: block;
`;
const styledWrapper = styled.div`
  padding: 3.333rem 0;
  width: 100%;
  background-color: #f6f6f6;
  font-size: 16px;
  font-weight: 300;
  font-style: normal;
  color: #bba868;
  text-align: center;
  line-height: 1.5;

  @media (max-width: 960px) {
    font-size: 16.5px;
    display: block;
  }
`;
const styledContainer = styled.div`
  max-width: 78em;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
`;

export default {
  data() {
    return {
      dataVersion: "1.1.1",
      language: "de",
      i18n: {
        de: {
          addressLine1: "BERNEXPO AG",
          addressLine2: "Mingerstrasse 6",
          addressLine3: "Postfach ",
          addressLine4: "CH-3000 Bern 22",
          labelPhone: "Tel.",
          labelFax: "Fax"
        },
        fr: {
          addressLine1: "BERNEXPO AG",
          addressLine2: "Mingerstrasse 6",
          addressLine3: "Case Postale ",
          addressLine4: "CH-3000 Berne 22",
          labelPhone: "Tél.",
          labelFax: "Fax"
        },
        en: {
          addressLine1: "BERNEXPO AG",
          addressLine2: "Mingerstrasse 6",
          addressLine3: "PO Box ",
          addressLine4: "CH-3000 Bern 22",
          labelPhone: "Tel.",
          labelFax: "Fax"
        }
      }
    };
  },
  props: {
    display: {
      type: String,
      default: "message"
    },
    navItems: {
      type: String,
      default: `[
        {
          "url": {
            "de": "https://portal.bernexpo.ch/imprint",
            "fr": "https://portal.bernexpo.ch/imprint",
            "en": "https://portal.bernexpo.ch/imprint"
          },
          "title": {
            "de": "Impressum",
            "fr": "Mentions légales",
            "en": "Imprint"
          }
        },
        {
         "url": {
            "de": "https://portal.bernexpo.ch/dataprotection",
            "fr": "https://portal.bernexpo.ch/dataprotection",
            "en": "https://portal.bernexpo.ch/dataprotection"
          },
          "title": {
            "de": "Datenschutzerklärung",
            "fr": "Déclaration de confidentialité",
            "en": "Privacy Statement"
          }
        }
      ]`
    }
  },
  computed: {
    parsedNavItem() {
      return JSON.parse(this.navItems);
    }
  },
  components: {
    styledWrapper,
    styledContainer,
    styledParagraph,
    styledSpan,
    styledSpanPhone,
    styledNav
  },
  name: "BexFooter",
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);

    //  Get params from url if not specified.

    if (urlParams.has("language")) {
      this.language = urlParams.get("language");
      localStorage.setItem("language", this.language);
    } else {
      if (localStorage.getItem("language")) {
        this.language = localStorage.getItem("language");
      }
    }
  }
};
</script>
